import { render, staticRenderFns } from "./ex-join.vue?vue&type=template&id=1df60352&scoped=true&"
import script from "./ex-join.vue?vue&type=script&lang=js&"
export * from "./ex-join.vue?vue&type=script&lang=js&"
import style0 from "./ex-join.vue?vue&type=style&index=0&id=1df60352&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df60352",
  null
  
)

export default component.exports